define.alias("shared/components/shared/loading-spinner", "calendar/components/shared/loading-spinner");